module.exports = __webpack_public_path__ + "static/Norman Sasono-07144740df9f6451f8656525b6296802.jpg";